(function($) {
    'use strict';

    window.addItemSizeToCart = function(variantId, quantity, messageId) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                'id': variantId,
                'quantity': quantity
            },
            dataType: 'json',
            success: function() {
                console.log('Item added to cart');
                updateCartCount();
                updateMessage('Added to bag', messageId);
                setTimeout(function() {
                    updateMessage('Select a size', messageId);
                }, 4000); // Set message back to 'Select a size' after 4 seconds
                openSlideOutCart();
            },
            error: function() {
                console.log('Failed to add item to cart');
            }
        });
    };

    window.addProductToCart = function(variantId, buttonElement) {

      var variantSelect = buttonElement.parentElement.querySelector('.variant-select');
      if (variantSelect) {
        variantId = variantSelect.value;
      }
    
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: 1
        },
        success: function() {
          console.log('Item added to cart');
          updateCartCount();
          openSlideOutCart();
        },
        error: function() {
          console.log('Failed to add item to cart');
        },
        dataType: 'json'
      });
    };

    function updateCartCount() {
        $.getJSON('/cart.js', function(cart) {
            $('.cart div').text(cart.item_count);
        });
    }

    function updateMessage(message, messageId) {
        $('#' + messageId).fadeOut(200, function() {
            $(this).text(message).fadeIn(200);
        });
    }

    $('body').on('click', '.SI_trigger', function() {
        var variantId = $(this).data('variant-id');
        $('#variants').val(variantId);
    });

  // Make updateMessage globally accessible
    window.updateMessage = updateMessage;

  // Size overlay
  $('.size-overlay-trigger').on('click', function() {
    $(this).siblings('.size-container').toggle();
  });

  // Slide out cart
  var freeShippingThreshold = parseFloat($('#slide-out-cart').data('free-shipping-threshold'));
  var showShippingBar = $('#slide-out-cart').data('show-shipping-bar');
  
  function openSlideOutCart() {
    $('#slide-out-cart').addClass('show');
    $('#so-bg-overlay').show();
  }

  function openSlideOutCart() {
    // Fetch the most up-to-date cart data from Shopify's AJAX API
    $.getJSON('/cart.js', function(cart) {
        // Clear the current contents of the cart
        $('.so-cart-items').empty();

        // Check if the cart is empty
        if (cart.item_count === 0) {
            // If the cart is empty, display a message
            var emptyCartHTML = `
              <p class="empty-cart-message">Your cart is empty. Shop now.</p>
              <ul class="empty-cart-links">
            `;
          $('.collection-link').each(function() {
              var url = $(this).data('url');
              var title = $(this).data('title');
              emptyCartHTML += `<li><a href="${url}">${title}</a></li>`;
          });
          emptyCartHTML += '</ul>';
            $('.so-cart-items').append(emptyCartHTML);
        } else {
            // If the cart is not empty, loop through each item in the cart
            $.each(cart.items, function(i, item) {
                // Build the HTML for the cart item.
                var priceHTML = '';
                var hasDiscount = item.original_price && item.final_price && item.original_price > item.final_price;
                
                if (hasDiscount) {
                    // Show both original and discounted price
                    priceHTML = `
                        <p>
                            <span style="text-decoration: line-through; color: #999;">$${(item.original_price / 100).toFixed(2)}</span>
                            <span style="">$${(item.final_price / 100).toFixed(2)}</span>
                        </p>
                    `;
                } else {
                    // Show regular price
                    priceHTML = `<p>$${(item.price / 100).toFixed(2)}</p>`;
                }
                
                // Build discount details if available
                var discountHTML = '';
                if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
                    discountHTML = '<div class="line-item-discounts" style="font-size: 0.9em; color: #c00; margin-top: 4px;">';
                    item.line_level_discount_allocations.forEach(function(discount) {
                        discountHTML += `<p>${discount.discount_application.title}</p>`;
                    });
                    discountHTML += '</div>';
                }
                
                var cartItemHTML = `
                  <div class="so-cart-item">
                      <div class="item-image"><img src="${item.image.replace('_1x1_crop_center.jpg', '_compact.jpg')}" width="85" height="115" alt="${item.product_title}"></div>
                      <div class="item-info">
                          <div>
                              <p class="cart-item-title">${item.product_title}</p>
                              ${(item.variant_options[0] && item.variant_options[0] !== 'Default Title') ? `<p class="cart-item-size">Size: ${item.variant_options[0]}</p>` : ""}
                              <!--
                              TODO: If we want to show the discount details on the cart page, we can uncomment this code.
                              ${discountHTML}
                              -->
                          </div>
                          <div class="price-quantity">
                              <div class="quantity-adjust">
                                  <div class="quantity">
                                      <button class="minus" data-line="${i + 1}" data-quantity="${item.quantity - 1}"><span>&minus;</span></button>
                                      <input class="select-on-focus" type="text" size="2" id="updates_${item.id}" name="updates[]" value="${item.quantity}" />
                                      <button class="plus" data-line="${i + 1}" data-quantity="${item.quantity + 1}"><span>&plus;</span></button>
                                  </div>
                              </div>
                              <div class="price-remove">
                                  ${priceHTML}
                                  <button class="remove" data-line="${i + 1}" data-quantity="0">Remove</button>
                              </div>
                          </div>
                      </div>
                  </div>
              `;

                // Append the cart item HTML to the cart content div
                $('.so-cart-items').append(cartItemHTML);
            });
        }

        // Update the cart subtotal
        $('.so-subtotal p:nth-child(2)').text('$' + (cart.total_price / 100).toFixed(2));

        if (cart.item_count > 0) {
          var amountAway = Math.max(0, freeShippingThreshold - cart.total_price / 100);
          var percentageFilled = Math.min(100, 100 * ((freeShippingThreshold - amountAway) / freeShippingThreshold));
        
          $('.so-free-shipping-bar .amount-away').text(amountAway.toFixed(2));
          $('.so-free-shipping-bar .fill-bar').css('width', percentageFilled + '%');
        
          // Check if cart total is below or above the free shipping threshold
          if (cart.total_price / 100 < freeShippingThreshold) {
            // If below, show the 'below-threshold' message and hide the 'above-threshold' message
            $('.so-free-shipping-bar .below-threshold').show();
            $('.so-free-shipping-bar .above-threshold').hide();
          } else {
            // If above, hide the 'below-threshold' message and show the 'above-threshold' message
            $('.so-free-shipping-bar .below-threshold').hide();
            $('.so-free-shipping-bar .above-threshold').show();
          }
        
          $('.so-free-shipping-bar').show();
        } else {
          // If the cart is empty, hide the progress bar
          $('.so-free-shipping-bar').hide();
        }

        // Check if the upsell product is in the cart
        var upsellHandle = $('.so-upsell-product').data('upsell-handle');
        var upsellInCart = cart.items.some(item => item.handle === upsellHandle);
        
        // Depending on the result, show or hide the upsell section
        if (upsellInCart) {
            $('.so-upsell-product').hide();
        } else {
            $('.so-upsell-product').show();
        }

        // Show the slide-out cart and the overlay
        $('#slide-out-cart').addClass('show');
        $('#so-bg-overlay').show();

        // update cart count
        updateCartCount();
    });
  }

  function closeSlideOutCart() {
      $('#slide-out-cart').removeClass('show');
      $('#so-bg-overlay').hide();
  }

  // Update quantity
  $(document).on('click', '.so-cart-item .minus, .so-cart-item .plus', function(e) {
      e.preventDefault();
      var line = $(this).data('line');
      var quantity = $(this).data('quantity');
  
      $.post('/cart/change.js', { line: line, quantity: quantity }, function(cart) {
          openSlideOutCart();
          // update cart count
          updateCartCount();
      }, 'json');
  });
  
  // Remove item
  $(document).on('click', '.so-cart-item .remove', function(e) {
      e.preventDefault();
      var line = $(this).data('line');
      var quantity = $(this).data('quantity');
  
      $.post('/cart/change.js', { line: line, quantity: quantity }, function(cart) {
          openSlideOutCart();
          // update cart count
          updateCartCount();
      }, 'json');
  });

  var previousCart = null;

  // Get the current state of the cart
  function getCartState() {
    return new Promise((resolve, reject) => {
      $.getJSON('/cart.js', function(cart) {
        // console.log('Fetched cart state:', cart);
        resolve(cart);
      }).fail(function() {
        reject('Failed to fetch cart');
      });
    });
  }

  // Poll the cart state until it changes
  function waitForCartStateChange(initialCartState) {
    const timeout = 10000; // 10 seconds
    const pollingInterval = 500; // 0.5 seconds
    const attempts = timeout / pollingInterval;
  
    return new Promise(function(resolve, reject) {
      let attemptsMade = 0;
  
      const intervalId = setInterval(function() {
        getCartState().then(function(newCartState) {
          attemptsMade++;
  
          // Check if the cart's total price has changed
          if (newCartState.total_price !== initialCartState.total_price) {
            clearInterval(intervalId);
            resolve();
          } else if (attemptsMade >= attempts) {
            clearInterval(intervalId);
            reject(new Error('Timed out waiting for cart state to change'));
          }
        });
      }, pollingInterval);
    });
  }

  // Tabs

  function setupTabs() {
    document.querySelectorAll('.block-tab-button').forEach(button => {
      button.addEventListener('click', () => {
        const sideBar = button.closest('.block-tabs-container');
        const tabNumber = button.dataset.tabTarget;
        const tabToActivate = sideBar.querySelector(`.block-tab-content[data-tab-content="${tabNumber}"]`);
  
        // Remove the 'block-active-content' class from all tab contents
        sideBar.querySelectorAll('.block-tab-content').forEach(tabContent => {
          tabContent.classList.remove('block-active-content');
        });
  
        // Add the 'block-active-content' class to the active tab content
        tabToActivate.classList.add('block-active-content');
  
        // Remove the 'active-tab-header' class from all tab buttons
        sideBar.querySelectorAll('.block-tab-button').forEach(tabButton => {
          tabButton.classList.remove('active-tab-header');
        });
  
        // Add the 'active-tab-header' class to the clicked tab button
        button.classList.add('active-tab-header');
      });
    });
  }

  // Accordion for filters
  function initializeSingleOpenAccordions() {
    // Get all the accordion elements within '.top-filter' divs
    const accordions = document.querySelectorAll('.top-filter #FacetsForm .cc-accordion');
  
    // Loop over each accordion and adjust its data attribute and enforce single-open behavior
    accordions.forEach(function(accordion) {
      // Set data-allow-multi-open to 'false'
      accordion.setAttribute('data-allow-multi-open', 'false');
  
      // Get all accordion items within this accordion
      const items = accordion.querySelectorAll('.cc-accordion-item');

      items.forEach(function(item) {
        item.classList.remove('is-open');
        item.removeAttribute('open');
        const panel = item.querySelector('.cc-accordion-item__panel');
        panel.style.height = '0px';
      });
      
      // // Attach click event listener to each accordion title
      // items.forEach(function(item) {
      //   const title = item.querySelector('.cc-accordion-item__title');
      //   title.addEventListener('click', function() {
      //     // Close all items except the one clicked
      //     items.forEach(function(otherItem) {
      //       if (otherItem !== item && otherItem.hasAttribute('open')) {
      //         otherItem.removeAttribute('open');
      //       }
      //     });
      //   });
      // });
    });
  }
  
  
  $(document).ready(function() {
      $('.so-cart-close-button').on('click', closeSlideOutCart);
  
      $(document).on('click', '.slidecart-icon', function(e) {
          e.preventDefault();
          openSlideOutCart();
      });

      $('.product-purchase-form .button').on('click', function(e) {
      
        getCartState().then(function(cart) {
          previousCart = cart;
          
          // Now wait for the cart state to change
          return waitForCartStateChange(previousCart);
      
        }).then(function(cart) {
          // The cart state has changed; now we can open the slide-out cart
          openSlideOutCart();
      
        }).catch(function(errorMessage) {
          // Handle any errors
          console.error(errorMessage);
        });
      });
  
      // Close the slide out cart when the overlay is clicked
      $('#so-bg-overlay').on('click', closeSlideOutCart);

      // Upsell add to cart
      $(document).on('click', '.add-upsell-to-cart', function() {
          var variantId = $(this).data('product-id');
          
          // Go up to the parent .shop-look-add and then find the select within that
          var variantSelect = $(this).closest('.shop-look-add').find('.variant-select');
          
          if (variantSelect.length) {
              variantId = variantSelect.val();
          }
          
          // Pass this (the clicked button) directly to the addProductToCart function
          addProductToCart(variantId, this);
      });

      $(document).on('click', '.btt', function() {
        $('html, body').animate({
          scrollTop: 0
        }, 800);
      });

      // Call the initializeTabs function to setup the tabs functionality
      setupTabs();

    initializeSingleOpenAccordions();

          // Close accordion item
      document.addEventListener('click', function(event) {
        // Check if the viewport width is greater than 767 pixels
        if (window.innerWidth > 767) {
          var clickedItem = event.target.closest('.cc-accordion-item');
          
          // Proceed only if an accordion item was clicked
          if (clickedItem) {
            // Loop through all <details> elements
            var allItems = document.querySelectorAll('.top-filter #FacetsForm .cc-accordion .cc-accordion-item');
            allItems.forEach(function(item) {
              // If the item is not the one that was clicked and it is open, close it
              if (item !== clickedItem && item.hasAttribute('open')) {
                item.removeAttribute('open');
              }
            });
        
            // If the clicked item is not already open, open it
            if (!clickedItem.hasAttribute('open')) {
              clickedItem.setAttribute('open', '');
            }
          }
        }
      });
  });

  // RSA Store Availability Updates
  function updateRSAAvailability(variantId) {
    var $rsaContainer = $('[data-rsa-availability-container]');
    
    if ($rsaContainer.length === 0) return;
    
    // var rsaLocationId = $rsaContainer.data('rsa-location-id');
    var availableText = $rsaContainer.data('available-text') || 'Available at RSA store';
    var unavailableText = $rsaContainer.data('unavailable-text') || 'Not available at RSA store';
    
    // Get the variant inventory data from the JSON script tag
    var $inventoryData = $('[data-rsa-variant-inventory]');
    
    if ($inventoryData.length > 0) {
      try {
        var variantInventoryData = JSON.parse($inventoryData.text());
        var variantData = variantInventoryData[variantId];
        
        if (variantData) {
          var rsaInventory = variantData.rsa_quantity || 0;
          var isAvailable = rsaInventory > 0 && variantData.available;
          
          updateRSADisplay(isAvailable, availableText, unavailableText, variantData);
        } else {
          // Variant not found in data
          updateRSADisplay(false, availableText, unavailableText, null);
        }
      } catch (e) {
        console.error('Error parsing RSA inventory data:', e);
        updateRSADisplay(false, availableText, unavailableText, null);
      }
    } else {
      // No inventory data found, fallback to unavailable
      updateRSADisplay(false, availableText, unavailableText, null);
    }
  }
  
  function updateRSADisplay(isAvailable, availableText, unavailableText, variantData) {
    var $indicator = $('[data-rsa-indicator]');
    var $text = $indicator.find('.rsa-availability-text');
    
    // Add changing class for animation
    $indicator.addClass('changing');
    
    setTimeout(function() {
      // Remove checking state
      $indicator.removeClass('rsa-availability--checking');
      
      if (isAvailable) {
        $indicator.removeClass('rsa-availability--unavailable').addClass('rsa-availability--available');
        $text.text(availableText);
      } else {
        $indicator.removeClass('rsa-availability--available').addClass('rsa-availability--unavailable');
        $text.text(unavailableText);
      }

      if (variantData && (variantData.available === 0 || variantData.available === false)) {
        $indicator.addClass('rsa-availability-hidden');
      } else {
        $indicator.removeClass('rsa-availability-hidden');
      }
      
      // Remove changing class after update
      setTimeout(function() {
        $indicator.removeClass('changing');
      }, 50);
    }, 150);
  }
  
  // Listen for variant changes - check multiple possible selectors
  $(document).on('change', 'select[name="id"], input[type="radio"][name="id"], .single-option-selector', function() {
    // Get the form and find the master variant selector
    var $form = $(this).closest('form');
    var variantId = $form.find('[name="id"]').val();
    
    if (variantId) {
      updateRSAAvailability(variantId);
    }
  });
  
  // Also listen for custom variant change events that the theme might trigger
  $(document).on('variantChange variant:change', function(event, variant) {
    if (variant && variant.id) {
      updateRSAAvailability(variant.id);
    }
  });
  
  // Barry theme specific variant change handling
  $(document).on('cc:variant:update', function(event, variant, form) {
    if (variant && variant.id) {
      updateRSAAvailability(variant.id);
    }
  });
  
  // Check RSA availability on page load
  $(document).ready(function() {
    var $rsaContainer = $('[data-rsa-availability-container]');
    if ($rsaContainer.length > 0) {
      var currentVariantId = $rsaContainer.data('current-variant-id');
      if (currentVariantId) {
        updateRSAAvailability(currentVariantId);
      }
    }
  });

})(jQuery);
